/**
 * PhoneInput — US phone number input with auto-formatting (+1 (XXX) XXX-XXXX)
 */

import { Input, InputProps } from '../Input';
import { formatUSPhone } from './phoneUtils';

interface PhoneInputProps extends Omit<InputProps, 'onChange' | 'value' | 'type'> {
  value: string;
  onChange: (formatted: string) => void;
}

export const PhoneInput = ({ value, onChange, ...rest }: PhoneInputProps) => (
  <Input
    type="tel"
    placeholder="+1 (555) 000-0000"
    value={value}
    onChange={(e) => onChange(formatUSPhone(e.target.value))}
    {...rest}
  />
);

export default PhoneInput;
